/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/account-info-1.css';
import { Button, Segment, Form, Input, Header, Checkbox, Grid, Progress } from 'semantic-ui-react';
import { Link, Redirect} from 'react-router-dom';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class AccountInfo1 extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      shipments: '',
      shipmentType: '',
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}
  
  handleRadioChange = (e, { value }) => this.setState({ value })

  handleSubmit = () => {
    const { shipments } = this.state

    this.setState({ shipments },
      console.log(this.state))

    API.busSize(
      this.getCookieValue('kxCustomerToken'),
      this.state.shipments,
      this.state.value
    ).then(response => {
      return response.json()
    }).then(responseData => {
      console.log(responseData);
    }).then(
      this.setState({ toNextPage: true })
    ).catch(err => console.log('ERROR:', err))

    // this.props.storeProgressData("ai1", "item progress-green")
  }

  handleSkip = () => {
    this.props.storeProgressData("ai1", "piece progress-gray")
  }

  render() {
    const { shipments } = this.state

    if (this.state.toNextPage === true) {
      this.props.storeProgressData("ai1", "piece progress-green")
			return <Redirect to='/accountInfo2' /> 
    }

    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        <div>
          <h2>Account Information</h2>
          <Segment padded='very' className="account-info-1-segment">
            <Form>
              <Header as='h1'>Business Size</Header>
              <Form.Group widths='equal'>

                      <Form.Input
                        fluid label='Number of Shipments'
                        placeholder='Shipments'
                        className="account-ino-1-input"
                        name="shipments"
                        value={shipments}
                        onChange={this.handleChange.bind(this)}
                      />

                      <Form.Radio
                        label='Monthly'
                        value='monthly'
                        checked={this.state.value === 'monthly'}
                        onChange={this.handleRadioChange}
                      />

                      <Form.Radio
                        label='Annually'
                        value='annually'
                        checked={this.state.value === 'annually'}
                        onChange={this.handleRadioChange}
                      />
              </Form.Group>
            </Form>

            <div className="ai1-buttonRow">
                <Link to='/basicinfo-company'>
                  <Button type='submit' className="account-info-1-cancel">CANCEL</Button>
                </Link>
                <Link to='/accountInfo2'>
                  <Button type='submit' className="account-info-1-skip" onClick={this.handleSkip}>SKIP THIS</Button>
                </Link>
                {/* <Link to='/accountInfo2'> */}
                  <Button type='submit' className="account-info-1-save" onClick={this.handleSubmit} color="twitter">SAVE & NEXT</Button>
                {/* </Link> */}
              </div>
          </Segment>
        </div>
      </div>
    );
  }
}

export default AccountInfo1;